import { ApiClient } from '@pocketbloom/shared'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api'

export const apiClient = new ApiClient(API_BASE_URL)

// Safe localStorage access for SSR compatibility
const isClient = typeof window !== 'undefined'
if (isClient) {
  const savedToken = localStorage.getItem('auth_token')
  if (savedToken) {
    apiClient.setToken(savedToken)
  }
}

export const setAuthToken = (token: string) => {
  if (isClient) {
    localStorage.setItem('auth_token', token)
  }
  apiClient.setToken(token)
}

export const clearAuthToken = () => {
  if (isClient) {
    localStorage.removeItem('auth_token')
  }
  apiClient.setToken(null)
}

export const getStoredToken = () => {
  return isClient ? localStorage.getItem('auth_token') : null
}

// Setup 401 handler - redirect to login and clear auth state
if (isClient) {
  apiClient.setUnauthorizedHandler(() => {
    console.warn('[Auth] 401 Unauthorized - clearing session and redirecting to login')
    clearAuthToken()

    // Disconnect socket if active
    import('./socketService').then(({ adminSocketService }) => {
      adminSocketService.disconnect()
    })

    // Redirect to login page
    window.location.href = '/login'
  })
}

